var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfocircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33105,
    y: 1.83276,
    width: 13.3333,
    height: 13.3333,
    rx: 6.66667,
    stroke: "url(#paint0_linear_668_16046)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33105 11.8333L8.33105 7.83325",
    stroke: "url(#paint1_linear_668_16046)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99772 7.83325L8.33105 7.83325",
    stroke: "url(#paint2_linear_668_16046)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33105 5.83293L8.33105 5.16626",
    stroke: "url(#paint3_linear_668_16046)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_668_16046",
    x1: 7.99772,
    y1: 1.83276,
    x2: 7.99772,
    y2: 15.1661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_668_16046",
    x1: 8.33105,
    y1: 9.83325,
    x2: 7.33105,
    y2: 9.83325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_668_16046",
    x1: 7.66439,
    y1: 7.83325,
    x2: 7.66439,
    y2: 6.83325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_668_16046",
    x1: 8.33105,
    y1: 5.49959,
    x2: 7.33105,
    y2: 5.49959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45AE51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#249B6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocircle);
export default __webpack_public_path__ + "static/media/Infocircle.c9b95a65e01d2c835a5fd937e59852d6.svg";
export { ForwardRef as ReactComponent };